import Vue from "vue";

Vue.filter('photoSwipeItemImages', function (images, accessor) {

    if (!images) {
        return [];
    }

    const imageUrls = [];
    let imagesAccessor = 'all';

    if (images.variation && images.variation.length) {
        imagesAccessor = 'variation';
    }

    for (const image in images[imagesAccessor]) {

        let imageUrl = images[imagesAccessor][image]['url'];
        let prevUrl  = images[imagesAccessor][image]['urlMiddle'];

        if (typeof imageUrl !== 'undefined') {
            imageUrls.push({
                src: imageUrl,
                position: images[imagesAccessor][image].position,
                w: 0,
                h: 0,
                msrc: prevUrl,
            });
        }
    }

    return imageUrls;
});
